import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container sudo-actions",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.modules.disablePromptHeader'),
      "open": _vm.moduleTogglePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: 'Siii',
        color: _vm.color,
        emit: 'toggle'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.moduleTogglePrompt = false;
      },
      "toggle": function ($event) {
        _vm.toggleModule(_vm.moduleToToggle, _vm.moduleDoDelete);
        _vm.moduleTogglePrompt = false;
      }
    }
  }, [_vm._v("\n    This will disable/enable the\n    "), _c('custom-code', [_vm._v(_vm._s(_vm.moduleToToggle))]), _vm._v("\n    module system-wide, including deleting/adding rules.\n  ")], 1), _vm.ruleDeletePrompt ? _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.system.modules.disablePromptHeader'),
      "open": _vm.ruleDeletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: 'Siii',
        color: _vm.color,
        emit: 'toggle'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.ruleDeletePrompt = false;
      },
      "toggle": function ($event) {
        _vm.deleteRule(_vm.ruleDeleteObj.id);
        _vm.ruleDeletePrompt = false;
      }
    }
  }, [_vm._v("\n    This will delete the rule\n    "), _c('custom-code', [_vm._v(_vm._s(_vm.ruleDeleteObj.name))]), _vm._v("\n    , removing it from any role as well.\n  ")], 1) : _vm._e(), _c(VForm, {
    ref: "mainForm",
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: _vm.formIsValid,
      callback: function ($$v) {
        _vm.formIsValid = $$v;
      },
      expression: "formIsValid"
    }
  }, [_c('core-header', {
    attrs: {
      "headline": "Super-System-Admin Terminal",
      "subtitle": "Fire away direct molecular actions 🚀"
    }
  }), _c('div', {
    staticClass: "n20-mainrow pt-4"
  }, [_c('core-n20Card', {
    staticClass: "mb-4",
    attrs: {
      "icon": "fa-terminal",
      "buttons": _vm.buttons
    },
    on: {
      "execAction": function ($event) {
        return _vm.execAction();
      }
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mt-4 py-0"
  }, [_c('p', [_vm._v("\n              This is like a mini\n              "), _c('custom-code', [_vm._v("interactive")]), _vm._v("\n              terminal for Super-System Admins with Laser-Level 8 or above, to execute internal molecular actions.\n            ")], 1), _c('p', [_vm._v("\n              To see all available actions, call\n              "), _c('custom-code', [_vm._v("$node.actions")]), _vm._v("\n              with\n              "), _c('custom-code', [_vm._v("{\"skipInternal\": true, \"onlyAvailable\": true}")]), _vm._v("\n              Or, for the wisest of the flog, just use your local\n              "), _c('custom-code', [_vm._v("interactive")]), _vm._v("\n              console for a nicer view and execute the action here then.\n            ")], 1)])], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "disabled": _vm.isLoading,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "label": "ACTION PATH"
    },
    model: {
      value: _vm.callPath,
      callback: function ($$v) {
        _vm.callPath = $$v;
      },
      expression: "callPath"
    }
  })], 1), _c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextarea, {
    attrs: {
      "disabled": _vm.isLoading,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.jsonRule,
      "label": "PARAMS (JSON)"
    },
    model: {
      value: _vm.params,
      callback: function ($$v) {
        _vm.params = $$v;
      },
      expression: "params"
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.errorResponse ? _c(VTextarea, {
    attrs: {
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Error.unknown'),
      "error": "",
      "readonly": ""
    },
    model: {
      value: _vm.errorResponse,
      callback: function ($$v) {
        _vm.errorResponse = $$v;
      },
      expression: "errorResponse"
    }
  }) : _vm._e(), _vm.validResponse ? _c('div', {
    staticStyle: {
      "padding": "12px",
      "border": "1px solid green",
      "border-radius": "8px"
    }
  }, [_c('pre', {
    staticStyle: {
      "width": "100%",
      "max-height": "450px",
      "overflow-y": "scroll"
    }
  }, [_vm._v(_vm._s(_vm.validResponse))])]) : _vm._e()], 1)], 1), _c(VRow, [_c(VCol, {
    staticClass: "my-0 py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    staticClass: "my-4",
    attrs: {
      "value": null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("MOLECULER ACTION LIST")])]), _c(VExpansionPanelContent, [_c(VSimpleTable, {
    staticClass: "mt-0 mb-2",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Action")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Parameters")])])]), _c('tbody', _vm._l(_vm.availableActions, function (action, i) {
          return _c('tr', {
            key: `action_${i}`
          }, [_c('td', [_c('custom-code', [_vm._v(_vm._s(action.name))])], 1), _c('td', _vm._l(Object.keys(action.params), function (param, idx) {
            return _c('custom-code', {
              key: idx
            }, [_vm._v("\n                              " + _vm._s(param) + "\n                            ")]);
          }), 1)]);
        }), 0)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('core-feature-flag', {
    attrs: {
      "flag": "rd-4938-drawerlinkconfig"
    }
  }, [_c('core-n20Card', {
    staticClass: "mb-4",
    attrs: {
      "icon": "fa-clipboard-list-check"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mt-4 py-0"
  }, [_c('p', [_vm._v("Edit the links in the navigation-drawer to your liking per account and domain.")])])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-rocket-launch",
      "to": "/drawer-links"
    }
  }, [_vm._v("Go editing")])], 1)], 1)], 1)], 1), _c('core-n20Card', {
    staticClass: "mb-4",
    attrs: {
      "icon": "fa-puzzle-piece"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mt-4 py-0"
  }, [_c('p', [_vm._v("Mark modules system-wide as deleted (also removing their rules) -- or enable them again.")])])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSimpleTable, {
    staticClass: "mt-0 mb-2",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.drawer.accountMgmtModules')))]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(_vm._s(_vm.$i18n_t('Common.action')))])])]), _c('tbody', _vm._l(_vm.modules, function (moduleModel, i) {
          return _c('tr', {
            key: `module_${i}`
          }, [_c('td', [_c('h4', {
            style: `opacity: ${!moduleModel.manifest.deletionMark ? 1.0 : 0.45}`
          }, [_c(VIcon, {
            attrs: {
              "color": !moduleModel.manifest.deletionMark ? _vm.color : undefined
            }
          }, [_vm._v("\n                          " + _vm._s(moduleModel.manifest.icon) + "\n                        ")]), _vm._v("\n                        " + _vm._s(moduleModel.manifest.name) + " (" + _vm._s(moduleModel.key) + ")\n                      ")], 1), _c('div', {
            style: `opacity: ${!moduleModel.manifest.deletionMark ? 1.0 : 0.65}`
          }, [_c('p', {
            domProps: {
              "innerHTML": _vm._s(moduleModel.manifest.description)
            }
          })])]), _c('td', {
            staticClass: "text-center"
          }, [!moduleModel.manifest.deletionMark ? _c('core-button', {
            attrs: {
              "color": "danger",
              "prepend-icon": "fa-times"
            },
            on: {
              "click": function ($event) {
                _vm.moduleToToggle = moduleModel.key;
                _vm.moduleDoDelete = true;
                _vm.moduleTogglePrompt = true;
              }
            }
          }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable')) + "\n                      ")]) : _c('core-button', {
            attrs: {
              "color": _vm.color,
              "prepend-icon": "fa-check-circle"
            },
            on: {
              "click": function ($event) {
                _vm.moduleToToggle = moduleModel.key;
                _vm.moduleDoDelete = false;
                _vm.moduleTogglePrompt = true;
              }
            }
          }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('accMgmt.tenant.integrations.activate')) + "\n                      ")])], 1)]);
        }), 0)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1), _c('core-n20Card', {
    staticClass: "mb-4",
    attrs: {
      "icon": "fa-user-unlock"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mt-4 py-0"
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('accMgmt.tenant.deleteRulesWarinig')) + "\n            ")])])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VSimpleTable, {
    staticClass: "mt-0 mb-2",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('tbody', _vm._l(_vm.rules, function (rule, i) {
          return _c('tr', {
            key: `rule_${i}`
          }, [_c('td', [_vm._v(_vm._s(rule.name))]), _c('td', {
            staticClass: "text-center",
            staticStyle: {
              "width": "150px"
            }
          }, [_c('core-button', {
            attrs: {
              "color": "danger"
            },
            on: {
              "click": function ($event) {
                _vm.ruleDeleteObj = rule;
                _vm.ruleDeletePrompt = true;
              }
            }
          }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('Common.delete')) + "\n                      ")])], 1)]);
        }), 0)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };